import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, genderTooltip, downloadData } from './helpers';
import * as axios from 'axios';

function ab109bars() {

  var margin = { top: 40, right: 70, bottom: 20, left: 500 },
    width = 960 - margin.left - margin.right,
    height = 200 - margin.top - margin.bottom;

  var svg = d3.select("#ab109bars")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform",
      "translate(" + margin.left + "," + margin.top + ")");

  const ab109Data = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
    .then(content => {

      const justData = content.data
      const pop = d3.csvParse(justData)

      const parseDate = d3.timeParse("%Y-%m-%d");

      pop.forEach((d, i) => {
        d.month = parseDate(d.date);
        d.count = +d.value;
      });
      pop.sort((a, b) => b.month - a.month)

      var currdate = pop[0].date

      const today = pop.filter(d => d.date == currdate)

      const csv = JSON.parse(JSON.stringify(today));
      const aobdata = csv.filter(d => d.subgroup == "N3 Partially Sentenced" || d.subgroup == "Parole Revocation 3000.08 FPC" || d.subgroup == "PRCS Revocation 3455" || d.subgroup == "Flash Incarceration 3454" || d.subgroup == "County Sentenced N3")

      aobdata.sort((a, b) => b.value - a.value)

      const totalCurrentAOB = d3.nest()
        .key(d => d.subgroup)
        .rollup(v => d3.sum(v, d => d.value))
        .entries(aobdata)

      totalCurrentAOB.forEach(function (d) {
        if (d.key == "Flash Incarceration 3454") { d.key = "Encarcelamiento “flash”" }
        else if (d.key == "N3 Partially Sentenced") { d.key = "Condenados parcialmente" }
        else if (d.key == "PRCS Revocation 3455") { d.key = "Revocación de la supervisión comunitaria después de la liberación" }
        else if (d.key == "Parole Revocation 3000.08 FPC") { d.key = "Revocación de la libertad condicional" }
      })

      var x = d3.scaleLinear()
        .domain([0, d3.max(totalCurrentAOB, d => +d.value)])
        .range([0, width]);
      svg.append("g")
        .attr("transform", "translate(0,2)")
        .call(d3.axisTop(x))
        .selectAll("text")
        .attr("transform", "translate(10,0)rotate(0)")
        .style("text-anchor", "end");

      var y = d3.scaleBand()
        .range([0, height])
        .domain(totalCurrentAOB.map(function (d) { return d.key; }))
        .padding(.1);

      svg.append("g")
        .call(d3.axisLeft(y))

      let bars = svg.selectAll(".bar")
        .data(totalCurrentAOB)
        .enter()
        .append("g")

      bars
        .append("rect")
        .attr("x", x(0))
        .attr("y", function (d) { return y(d.key); })
        .attr("width", function (d) { return x(d.value); })
        .attr("height", y.bandwidth())
        .attr("fill", "#4D4E56")


      bars
        .append("text")
        .attr("x", d => x(d.value) + 10)
        .attr("y", d => y(d.key) + (y.bandwidth() / 2) + 5)
        .text(d => d.value)

    })

}

export { ab109bars }
